// src/pages/internal/perfil/formCircuito/cardSelection.js
import { useState } from "react";
import {
	Card,
	CardActionArea,
	Grid,
	Typography,
	useTheme, CardMedia,
	IconButton,
	Menu,
	MenuItem,
	ListItemIcon,
	ListItemText,
	Divider,
	Tooltip,
} from "@mui/material";
import { alpha, Box, darken } from "@mui/system";
import {
	ExpandMore,
	ExpandLess,
	DeleteOutlineOutlined,
	MoreVert,
	ArrowUpwardOutlined,
	SubdirectoryArrowRightOutlined,
	ContentCopyOutlined,
	AttachFileOutlined,
	MapOutlined,
} from "@mui/icons-material";

export default function CardSelection(params) {
	const {
		selected = false,
		childSelected = false,
		title,
		onClick,
		subtitle,
		hasChildren = false,
		isChild = false,
		isExpanded = false,
		onToggleExpand,
		onDelete,
		onPromote,
		onDemote,
		onDuplicate,
		idTrecho,
		index,
		anexosCount = 0,
		hasKmz = false,

	} = params;

	const theme = useTheme();
	const [menuAnchor, setMenuAnchor] = useState(null);

	const handleDeleteClick = (event) => {

		event.stopPropagation();
		setMenuAnchor(null);

		if (onDelete) onDelete(idTrecho);
	};

	const handleOpenMenu = (event) => {
		event.stopPropagation();
		setMenuAnchor(event.currentTarget);
	};

	const handleCloseMenu = (event) => {
		event?.stopPropagation?.();
		setMenuAnchor(null);
	};

	const handlePromoteClick = (event) => {
		event.stopPropagation();
		setMenuAnchor(null);
		if (onPromote) onPromote(idTrecho);
	};

	const handleDemoteClick = (event) => {
		event.stopPropagation();
		setMenuAnchor(null);
		if (onDemote) onDemote(idTrecho);
	};

	const handleDuplicateClick = (event) => {
		event.stopPropagation();
		setMenuAnchor(null);
		if (onDuplicate) onDuplicate(idTrecho);
	};

	const canPromote = isChild && typeof onPromote === "function";
	const canDemote = !isChild && !hasChildren && typeof onDemote === "function";
	const canDuplicate = typeof onDuplicate === "function";
	const canDelete = typeof onDelete === "function";
	const showMenu = canPromote || canDemote || canDuplicate || canDelete;


	return (
		<Grid sx={{ mt: 0.5, ml: isChild ? 1 : 0 }}>
			<Card variant="outlined">
				<Box
					data-active={selected ? "" : undefined}
					data-child-active={childSelected && !selected ? "" : undefined}
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "stretch",
						border: selected ?
							` 2px solid ${theme.palette.colors.green.light}`
							: "none",


						position: "relative",
						"&::before": {
							content: '""',
							position: "absolute",
							left: 0,
							top: 0,
							width: "5px",
							height: "100%",
							bgcolor: theme.palette.colors.green.light,
						},
						"&[data-active]": {
							backgroundColor: "action.selected",
							"&:hover": {
								backgroundColor: "action.selectedHover",
							},
						},
						"&[data-child-active]": {
							backgroundColor: theme.palette.mode === "dark" ? alpha(theme.palette.colors.green.light, 0.2) : alpha(theme.palette.colors.green.medium, 0.1),
							"&:hover": {
								backgroundColor: "action.selectedHover",
							},
						},
					}}>

					{hasChildren && (
						<CardMedia
							sx={{
								width: "auto",
								minWidth: "40px",
								display: "flex",
								borderLeft: "none",
								position: "relative",

							}}
						>
							<CardActionArea
								onClick={onToggleExpand}
								onMouseDown={(e) => e.stopPropagation()} // Previne cliques acidentais arrastando
								size="small"
								sx={{
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									height: "100%",
									width: "100%",
									transition: "background-color 0.2s",

								}}
							>
								{isExpanded ? <ExpandLess /> : <ExpandMore />}
							</CardActionArea>
						</CardMedia>

					)}
					<CardActionArea
						data-active={selected ? "" : undefined}
						sx={{
							paddingY: 1.5,
							paddingX: !hasChildren ? 1.5 : 0
						}}
						onClick={onClick}
					>
						<Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>

							<Box sx={{ p: 0.5, flexGrow: 1, minWidth: 0 }}>
								<Typography
									sx={{ fontWeight: "bold", fontSize: "14px" }}
									component="span"
								>
									{`${title}`}
								</Typography>
								<Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
									<Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>
										CNL: {subtitle}
									</Typography>
								</Box>
							</Box>

							<Box
								sx={{
									display: "flex",
									alignItems: "center",
									gap: 0.25,
									pr: 0.5,
									flexShrink: 0,
								}}
							>
								<Tooltip
									title={
										anexosCount > 0
											? `${anexosCount} anexo${anexosCount > 1 ? "s" : ""}`
											: "Este trecho não possui anexo cadastrado"
									}
									arrow
								>
									<Box
										sx={{
											display: "flex",
											alignItems: "center",
											gap: 0.25,
											color: anexosCount > 0
												? theme.palette.colors.green.medium
												: theme.palette.text.disabled,
										}}
									>
										<AttachFileOutlined sx={{ fontSize: 18 }} />
										<Typography
											sx={{
												fontSize: "12px",
												fontWeight: 600,
												minWidth: 10,
												textAlign: "left",
											}}
										>
											{anexosCount}
										</Typography>
									</Box>
								</Tooltip>
								<Tooltip
									title={
										hasKmz
											? "Mapa (KMZ) cadastrado"
											: "Este trecho não possui mapa cadastrado"
									}
									arrow
								>
									<Box
										sx={{
											display: "flex",
											alignItems: "center",
											ml: 0.5,
											color: hasKmz
												? theme.palette.colors.blue.light
												: theme.palette.text.disabled,
										}}
									>
										<MapOutlined sx={{ fontSize: 18 }} />
									</Box>
								</Tooltip>
							</Box>
						</Box>
					</CardActionArea>
					{showMenu && (
						<CardMedia
							sx={{
								width: "auto",
								minWidth: "40px",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								borderLeft: "none",
							}}
						>
							<Tooltip title="Mais ações">
								<IconButton size="small" onClick={handleOpenMenu}>
									<MoreVert fontSize="small" />
								</IconButton>
							</Tooltip>
							<Menu
								anchorEl={menuAnchor}
								open={Boolean(menuAnchor)}
								onClose={handleCloseMenu}
								onClick={(e) => e.stopPropagation()}
							>
								{canPromote && (
									<Tooltip title="Promover este subtrecho a trecho de nível superior" placement="left" arrow>
										<MenuItem onClick={handlePromoteClick}>
											<ListItemIcon>
												<ArrowUpwardOutlined fontSize="small" />
											</ListItemIcon>
											<ListItemText primary="Promover" />
										</MenuItem>
									</Tooltip>
								)}
								{canDemote && (
									<Tooltip title="Tornar este trecho um subtrecho de outro" placement="left" arrow>
										<MenuItem onClick={handleDemoteClick}>
											<ListItemIcon>
												<SubdirectoryArrowRightOutlined fontSize="small" />
											</ListItemIcon>
											<ListItemText primary="Rebaixar" />
										</MenuItem>
									</Tooltip>
								)}
								{canDuplicate && (
									<Tooltip title="Duplicar este trecho com todas as informações" placement="left" arrow>
										<MenuItem onClick={handleDuplicateClick}>
											<ListItemIcon>
												<ContentCopyOutlined fontSize="small" />
											</ListItemIcon>
											<ListItemText primary="Duplicar" />
										</MenuItem>
									</Tooltip>
								)}
								{canDelete && (canPromote || canDemote || canDuplicate) && <Divider />}
								{canDelete && (
									<Tooltip title="Excluir este trecho permanentemente" placement="left" arrow>
										<MenuItem
											onClick={handleDeleteClick}
											sx={{
												color: "error.main",
												"&:hover": {
													backgroundColor: alpha(theme.palette.error.main, 0.08),
												},
											}}
										>
											<ListItemIcon>
												<DeleteOutlineOutlined fontSize="small" color="error" />
											</ListItemIcon>
											<ListItemText primary="Excluir" primaryTypographyProps={{ color: "error" }} />
										</MenuItem>
									</Tooltip>
								)}
							</Menu>
						</CardMedia>
					)}
				</Box>
			</Card>
		</Grid>
	);
}